import { useEffect, useState } from 'react';
/**
 * Returns a value that only updates `delayMs` after the most recent change to
 * its input — used to avoid firing a query on every keystroke.
 */ export function useDebouncedValue(value, delayMs = 250) {
    const [debounced, setDebounced] = useState(value);
    useEffect(()=>{
        const t = setTimeout(()=>setDebounced(value), delayMs);
        return ()=>clearTimeout(t);
    }, [
        value,
        delayMs
    ]);
    return debounced;
}
